<!-- Contact Us -->
<div class="row justify-content-center m-0">
    <div class="col-lg-8" *ngIf="contactUsRequest">

        <h2 translate class="mt-3">MAP.GUIDES_DASHBOARD.CONTACT_US.LABEL</h2>
        <br>

        <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{'MAP.GUIDES_DASHBOARD.CONTACT_US.MESSAGE'| translate}}</mat-label>
            <textarea matInput rows="6" [(ngModel)]="contactUsRequest.body"></textarea>
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="send()">
            <mat-icon>send</mat-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SEND' | translate }}
        </button>

    </div>
</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>